import type { ClientConfig } from './types'
import { buildClientConfig } from './clientConfigBuilder'

// Webpack discovers every *.config.json in ./clients at build time. 'lazy' keeps
// each client in its own chunk, so only the active client's config is fetched at
// runtime. The file basename is the registry key (enforced against the JSON's
// own clientId by buildClientConfig).
const ctx = require.context('./clients', false, /\.config\.json$/, 'lazy')

export const clientLoaders: Record<string, () => Promise<ClientConfig>> = ctx
  .keys()
  .reduce<Record<string, () => Promise<ClientConfig>>>((acc, key) => {
    const clientId = key.replace(/^\.\/(.+)\.config\.json$/, '$1')
    acc[clientId] = async () => {
      const mod = (await ctx(key)) as { default?: unknown }
      return buildClientConfig(mod.default ?? mod, clientId)
    }
    return acc
  }, {})

export const KNOWN_CLIENT_IDS: readonly string[] = Object.keys(clientLoaders)
